import { STATE_HINTS } from '../policies/accessorial-labels.policy';
import type { AccessorialProposal } from '../trip-accessorials.api';

/** The cautions and the closer's own reason under a proposal's amount. */
export function ProposalNotes({ proposal }: { proposal: AccessorialProposal }) {
  const hint = STATE_HINTS[proposal.state];
  const reason = proposal.state === 'stale' ? null : proposal.decision?.reason;
  return (
    <>
      {proposal.onlyDriverTap && <p className="text-sm text-warning">Only the driver&apos;s own tap supports this: no position or office record backs it.</p>}
      {hint && <p className="text-sm text-warning">{hint}</p>}
      {reason && <p className="text-sm text-muted">Reason: {reason}</p>}
    </>
  );
}
